module.exports = __webpack_public_path__ + "img/CROWN LIME.d978fc0.svg";